"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useConceptOfferHintData = void 0;
var _basketUpdated = require("@ori-events/basket-updated");
var _react = require("react");
var _logger = require("../logger");
var _utils = require("../utils");
var _useAddBasketOffer = require("./useAddBasketOffer");
var _useAddConceptOfferHintError = require("./useAddConceptOfferHintError");
var _useAvailability = require("./useAvailability");
var _useConceptOfferHintDisplayedItems = require("./useConceptOfferHintDisplayedItems");
var _useConceptOfferHintHandlers = require("./useConceptOfferHintHandlers");
var _useConceptOfferHintPrices = require("./useConceptOfferHintPrices");
var _useConceptOfferHintSelections = require("./useConceptOfferHintSelections");
var _useExpandableOfferItemsLists = require("./useExpandableOfferItemsLists");
var _useNormalizedOfferItems = require("./useNormalizedOfferItems");
const useConceptOfferHintData = (offer)=>{
    const { benefitsQuantity: rawBenefitsQuantity, offerId, offerType: rawOfferType } = offer;
    const benefitsQuantity = rawBenefitsQuantity !== null && rawBenefitsQuantity !== void 0 ? rawBenefitsQuantity : 0;
    const offerType = rawOfferType;
    const isChooseAndChoose = offerType === _basketUpdated.BasketOfferTypes.CHOOSE_AND_CHOOSE;
    // Basic data transformation to have products / benefits collections
    // properly set, including marked purchased items.
    const rawOfferData = (0, _useNormalizedOfferItems.useNormalizedOfferItems)(offer);
    const { items1stSection, items2ndSection } = rawOfferData;
    const offerData = {
        ...offer,
        benefitsQuantity,
        isChooseAndChoose,
        offerType,
        ...rawOfferData
    };
    (0, _utils.logOfferData)(offerData);
    // Optional availability (out-of-stock data) comes in failed
    // apply offer response.
    const availabilityData = (0, _useAvailability.useAvailability)(offerData);
    const { isOfferApplicable } = availabilityData;
    // User selections in offer items / benefits.
    const selectionsData = (0, _useConceptOfferHintSelections.useConceptOfferHintSelections)({
        ...offerData,
        ...availabilityData
    });
    const { isBenefitsMinimumLimitMet, isRequirementMet } = selectionsData;
    // Separated prices & totals logic.
    const pricesData = (0, _useConceptOfferHintPrices.useConceptOfferHintPrices)({
        ...offerData,
        ...selectionsData
    });
    // Specific failed apply offer response callback for ConceptOfferHint.
    // Availability state is updated here. Optionally, the whole offer
    // removal is scheduled here, if the offer can't be applied.
    const onAddOfferFailedCallback = (0, _useAddConceptOfferHintError.useAddConceptOfferHintError)({
        ...offerData,
        ...availabilityData,
        ...selectionsData
    });
    // Generic add-offer logic.
    const addOfferData = (0, _useAddBasketOffer.useAddBasketOffer)(offerId, onAddOfferFailedCallback);
    // Handler definitions used in ConceptOfferHint.
    const handlersData = (0, _useConceptOfferHintHandlers.useConceptOfferHintHandlers)({
        ...offerData,
        ...availabilityData,
        ...addOfferData,
        ...selectionsData
    });
    // Logic for expanding large offer items lists.
    const visibleItemsData = (0, _useExpandableOfferItemsLists.useExpandableOfferItemsLists)({
        items1stSection,
        items2ndSection
    });
    // Final displayed offer data transformations, so that it doesn't have
    // to be mixed in the rendered markup.
    const displayedData = (0, _useConceptOfferHintDisplayedItems.useConceptOfferHintDisplayedItems)({
        ...offerData,
        ...availabilityData,
        ...selectionsData,
        ...pricesData,
        ...handlersData,
        ...visibleItemsData
    });
    const isOfferActionDisabled = (0, _react.useMemo)(()=>!isRequirementMet || isChooseAndChoose && !isBenefitsMinimumLimitMet, [
        isBenefitsMinimumLimitMet,
        isChooseAndChoose,
        isRequirementMet
    ]);
    (0, _logger.logDebug)('isOfferApplicable()', isOfferApplicable());
    (0, _logger.logDebug)(selectionsData);
    return {
        ...offerData,
        ...availabilityData,
        ...addOfferData,
        ...selectionsData,
        ...handlersData,
        ...pricesData,
        ...visibleItemsData,
        ...displayedData,
        isOfferActionDisabled
    };
};
exports.useConceptOfferHintData = useConceptOfferHintData;
